import { axiosInterceptor } from "../authInterceptor";
import environment from "../../../../environments/environment";


export async function getRcboInvoiceListDetails(Vivo: any) {
  try {
    const getAutoDebitResponse = await axiosInterceptor.post(`${environment.postRcboInvoiceList}`, Vivo);
    return getAutoDebitResponse;
  } catch (error: any) {
    return error;
  }
}

interface PartTypes {
  page: number
  size: number
  isActive: string
}

export async function getAllParticipants(partcipantDetails: PartTypes) {
  try {
    const getParticipantsDetails = await axiosInterceptor.post(`${environment.getAllParticipants}`, partcipantDetails);
    return { data: getParticipantsDetails, error: undefined };
  } catch (error: any) {
    const errorMessage = error.response || 'An error occurred';
    return { data: undefined, error: errorMessage };
  }

}

export async function saveMakePaymentDetails(Vivo: any) {
  try {
    const getAutoDebitResponse = await axiosInterceptor.post(`${environment.saveMakePayment}`, Vivo);
    return getAutoDebitResponse;
  } catch (error: any) {
    return error;
  }
}

export async function getInvoiceDetails(nsInvoiceNo: number,Pid:number, clientId: number) {
  try {
    const response = await axiosInterceptor.get(`${environment.baseUrl}ns-invoice/rcbo/${nsInvoiceNo}?participantId=${Pid}&clientId=${clientId}`);
    return response;
  } catch (error: any) {
    return error;
  }
}

export async function getRCBOSourceListByPid(participantId: number, clientId: number) {
  try {
    const getResponse = await axiosInterceptor.get(`${environment.getRCBOSourceListByPid}/${participantId}?projectNumber=0&isActive=Y&clientId=${clientId}`);
    return getResponse;
  } catch (error: any) {
    return error;
  }
}